import { jsx } from "react/jsx-runtime";
import { Button, Box } from "@zillow/constellation-10";
import { IconChevronRightOutline } from "@zillow/constellation-icons";
function ArrowBlockButton({
  children,
  href,
  target = "_blank",
  css: cssProp,
  className,
  onClick
}) {
  return /* @__PURE__ */ jsx(
    Button,
    {
      asChild: true,
      tone: "brand",
      emphasis: "outlined",
      fluid: true,
      icon: /* @__PURE__ */ jsx(IconChevronRightOutline, {}),
      iconPosition: "end",
      css: {
        justifyContent: "space-between",
        ...cssProp
      },
      className,
      children: /* @__PURE__ */ jsx("a", { href, target, onClick, children: /* @__PURE__ */ jsx(Box, { css: {
        textAlign: "left"
      }, children }) })
    }
  );
}
export {
  ArrowBlockButton as default
};
